import { Navbar } from "@/components/marketing/Navbar";
import { Hero } from "@/components/marketing/Hero";
import { Marquee } from "@/components/marketing/Marquee";
import { Services } from "@/components/marketing/Services";
import { WebsiteCare } from "@/components/marketing/WebsiteCare";
import { Portfolio } from "@/components/marketing/Portfolio";
import { Process } from "@/components/marketing/Process";
import { WhyChooseUs } from "@/components/marketing/WhyChooseUs";
import { About } from "@/components/marketing/About";
import { QuoteForm } from "@/components/quote/QuoteForm";
import { Contact } from "@/components/marketing/Contact";
import { Footer } from "@/components/marketing/Footer";
import { useLenis } from "@/lib/scroll";

export default function HomePage() {
  useLenis();
  return (
    <>
      <Navbar />
      <main id="main">
        <Hero />
        <Marquee />
        <Services />
        <WebsiteCare />
        <Portfolio />
        <Process />
        <WhyChooseUs />
        <About />
        <QuoteForm />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
